/** The filters a conversation list offers: its type (review or other), and on the
 * team's list across sites, its project. */
import { useProjectsList } from "../api/hooks/useProjectsList";
import { projectDisplayName } from "../utils/projectName";
import { MultiSelectFilter } from "./MultiSelectFilter";
import { CONVERSATION_TYPE_LABEL } from "../utils/conversationTypes";

const TYPES = Object.keys(CONVERSATION_TYPE_LABEL);

export const TypeFilter = ({
  selected,
  onChange,
}: {
  selected: string[];
  onChange: (next: string[]) => void;
}) => (
  <MultiSelectFilter
    options={TYPES}
    selected={selected}
    onChange={onChange}
    noun={{ one: "type", many: "types" }}
    labelOf={(type) => CONVERSATION_TYPE_LABEL[type] ?? type}
    searchable={false}
  />
);

export const ProjectFilter = ({
  selected,
  onChange,
}: {
  selected: string[];
  onChange: (next: string[]) => void;
}) => {
  const projects = useProjectsList().data ?? [];
  const names = new Map(projects.map((p) => [p.project_id, projectDisplayName(p)]));
  return (
    <MultiSelectFilter
      options={[...names.keys()].sort((a, b) =>
        (names.get(a) ?? a).localeCompare(names.get(b) ?? b, "en-GB"),
      )}
      selected={selected}
      onChange={onChange}
      noun={{ one: "project", many: "projects" }}
      labelOf={(id) => names.get(id) ?? id}
    />
  );
};
